// composables/useAppInit.js
import { getCurrentInstance } from 'vue'
import { useQuasar } from 'quasar'

export function useAppInit() {
  const { proxy } = getCurrentInstance()
  const $q = useQuasar()

  const initializeUser = async () => {
    // Ako je keycloak authenticated, dohvati fresh podatke
    if (proxy.$keycloak.authenticated) {
      try {
        let ref = ""
        if (proxy.$route.query.ref) {
          ref = "/" + proxy.$route.query.ref
        }
        
        const ret = await proxy.get('Auth/GetUser' + ref)
        if (ret) {
          proxy.$store.userData = ret
          $q.localStorage.set('userData', ret)
          
          if (ret.is_admin) {
            proxy.$store.users = await proxy.get('Auth/GetUsers')
          }
        } else {
          console.error('User not found')
          proxy.$logout()
        }
      } catch (error) {
        console.error('Failed to load user:', error)
      }
    }
  }


  return {
    initializeUser
  }
}